/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamLangsExamlangidItemsQueryResponse,
  GetApiV1ExamLangsExamlangidItemsPathParams,
  GetApiV1ExamLangsExamlangidItemsQueryParams,
  GetApiV1ExamLangsExamlangidItems401,
  GetApiV1ExamLangsExamlangidItems404,
  GetApiV1ExamLangsExamlangidItems500,
} from "../../types/examEvaluationController/GetApiV1ExamLangsExamlangidItems.ts";

function getGetApiV1ExamLangsExamlangidItemsUrl(
  examLangId: GetApiV1ExamLangsExamlangidItemsPathParams["examLangId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/langs/${examLangId}/items` as const,
  };
  return res;
}

/**
 * @description Retorna a lista paginada de questões associadas ao idioma de prova informado. **(Requer Authorization para autenticação)**
 * @summary Listar questões de um idioma de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/langs/:examLangId/items}
 */
export async function getApiV1ExamLangsExamlangidItems(
  examLangId: GetApiV1ExamLangsExamlangidItemsPathParams["examLangId"],
  params?: GetApiV1ExamLangsExamlangidItemsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamLangsExamlangidItemsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamLangsExamlangidItems401
      | GetApiV1ExamLangsExamlangidItems404
      | GetApiV1ExamLangsExamlangidItems500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamLangsExamlangidItemsUrl(examLangId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
